import Vue from 'vue'
import Router from 'vue-router'
import iframe from '../views/iframe.vue'
import center from '../views/center.vue'

import Rotation from '../components/Rotation'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'hash',
  scrollBehavior: () => {

    history.pushState(null, null, document.URL)

  },
  routes: [{
      path: '/',
      name: 'Layout',
      component: iframe,
      redirect: '/index',
      // 个人信息
      children: [{
          path: '/personalCenter',
          name: 'personalCenter',
          component: () => import('@/views/personalCenter/index'),
        },
        // 查询资质人员
        // 创新管理师
        {
          path: '/Inspection',
          name: 'Inspection',
          component: () => import('@/views/Inspection'),
        },
        // 分级评价
        {
          path: '/evaluation',
          name: 'evaluation',
          component: () => import('@/views/evaluation'),
        },
        // 知识产权质量
        {
          path: '/Quality',
          name: 'Quality',
          component: () => import('@/views/Quality'),
        },
        // 战略合作伙伴人员
        {
          path: '/personAll',
          name: 'personAll',
          component: () => import('@/views/personAll'),
        },
        // 质量提升辅导人员
        {
          path: '/Qualitys',
          name: 'Qualitys',
          component: () => import('@/views/Qualitys'),
        },
        // 资质查验结果
        {
          path: '/InspectionPerson',
          name: 'InspectionPerson',
          component: () => import('@/components/InspectionPerson'),
        },
        {
          path: '/resultQuery',
          name: 'resultQuery',
          component: () => import('@/components/resultQuery'),
        },
        // 资质维护
        {
          path: '/Qualification',
          name: 'Qualification',
          component: () => import('@/components/Qualification'),
        },
        // 资质升级
        {
          path: '/qualificaUpgrade',
          name: 'qualificaUpgrade',
          component: () => import('@/components/qualificaUpgrade'),
        },
        // 建设中页面
        {
          path: '/upgrade',
          name: 'upgrade',
          component: () => import('@/components/upgrade'),
        },
        
        // 新闻公告
        {
          path: '/Rotation',
          name: 'Rotation',
          component: Rotation,
        },
        {
          path: '/rotationLook',
          name: 'rotationLook',
          component: () => import('@/components/rotationLook'),
        },
        // 知识产权质量人员
        {
          path: '/Enterpriseinformation',
          name: 'Enterpriseinformation',
          component: () => import('@/views/qualificationApplication/Enterpriseinformation'),
        },
        // 质量提升辅导人员
        {
          path: '/Enterpriseinformations',
          name: 'Enterpriseinformations',
          component: () => import('@/views/qualificationApplication/Enterpriseinformations'),
        },
        // 咨询师
        {
          path: '/consultant',
          name: 'consultant',
          component: () => import('@/views/qualificationApplication/consultant'),
        },
        // 游戏主持人
        {
          path: '/gameMaster',
          name: 'gameMaster',
          component: () => import('@/views/qualificationApplication/gameMaster'),
        },
        {
          path: '/ChangePassword',
          name: 'ChangePassword',
          component: () => import('@/components/ChangePassword'),
        },
      ]
    },

    // 首页
    {
      path: '/index',
      name: 'index',
      component: center,
    },
    
    {
      
      path: '/phoneRotation',
      name: 'phoneRotation',
      component: () => import('@/components/phoneRotation'),
    },
    {
      path: '/Empty',
      name: 'Empty',
      component: () => import('@/components/Empty'),
    },
    // 登录
    {
      path: '/Signin',
      name: 'Signin',
      component: () => import('@/views/Signin'),
    },
    // 注册
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/register'),
    },
    
    // 异常
    {
      path: '/abnormal',
      name: 'abnormal',
      component: () => import('@/components/abnormal'),
    },
    // 知识产权质量评价人员信息采集
   
    // {
    //   path: '/Inspection',
    //   name: 'Inspection',
    //   component: () => import('@/views/Inspection'),
    // },
    // // 分级评价
    // {
    //   path: '/evaluation',
    //   name: 'evaluation',
    //   component: () => import('@/views/evaluation'),
    // },
    // // 知识产权质量
    // {
    //   path: '/Quality',
    //   name: 'Quality',
    //   component: () => import('@/views/Quality'),
    // },
    // 资质查验结果
    // {
    //   path: '/InspectionPerson',
    //   name: 'InspectionPerson',
    //   component: () => import('@/components/InspectionPerson'),
    // },

  ]
})